module.exports = __webpack_public_path__ + "static/media/Mask Group 8@2x.1773d702.png";